export default "__VITE_ASSET__DRRSMalw__";